var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"coupon-sucess-badge"},[_c('img',{attrs:{"src":require("../assets/images/celeb.svg"),"alt":""}}),_c('span',{staticClass:"coupon-sucess-text"},[_vm._v(_vm._s(_vm.label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }